<div class="modal-header" id="time-manual-input-modal-title">
    <h3 class="modal-title" id="modal-title" translate="TIME_INPUT_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="timeInputForm">
        <div class="row mb-3 justify-content-center">
            <div class="col-4">
                <label for="hoursInput" translate="TIME_INPUT_HOURS" class="mb-2"></label>
                <input
                    #hoursInput
                    id="hoursInput"
                    type="text"
                    inputmode="numeric"
                    class="form-control input-md number-input"
                    paceCoreNumberOnly
                    [formControl]="hoursInputControl"
                    [maxLength]="inputMaxLength"
                    [maxValue]="is12HoursFormat ? maxHoursFor12HourFormat : maxHoursFor24HourFormat"
                    (keyup)="onHoursKeyUp($event, hoursInput)"
                    (keypress)="onKeyPress($event)"
                    (keyup.enter)="submitTimeOnEnter()"
                />
            </div>
            <div class="col-4">
                <label for="minutesInput" translate="TIME_INPUT_MINUTES" class="mb-2"></label>
                <input
                    #minutesInput
                    id="minutesInput"
                    type="text"
                    inputmode="numeric"
                    class="form-control input-md number-input"
                    paceCoreNumberOnly
                    [maxLength]="inputMaxLength"
                    [maxValue]="inputMinuteMaxValue"
                    [formControl]="minutesInputControl"
                    (keyup.enter)="submitTimeOnEnter()"
                />
            </div>
        </div>

        <ng-container *ngIf="is12HoursFormat">
            <div class="row mb-3">
                <div class="col-4 offset-2">
                    <button
                        class="btn btn-lg w-100"
                        type="button"
                        [ngClass]="meridiem === MERIDIEM.AM ? 'btn-success' : 'btn-link'"
                        [disabled]="hoursInputControl.value === maxHoursFor12HourFormat"
                        (click)="onMeridiemChange(false)"
                        (keyup.enter)="submitTimeOnEnter()"
                    >
                        {{ MERIDIEM.AM }}
                    </button>
                </div>
                <div class="col-4">
                    <button
                        class="btn btn-lg w-100"
                        type="button"
                        [ngClass]="meridiem === MERIDIEM.PM ? 'btn-success' : 'btn-link'"
                        (click)="onMeridiemChange(true)"
                        (keyup.enter)="submitTimeOnEnter()"
                    >
                        {{ MERIDIEM.PM }}
                    </button>
                </div>
            </div>
        </ng-container>

        <div *ngIf="timeInputForm.invalid" class="text-danger error-text">{{ warningText }}</div>
    </form>
</div>
<div class="modal-footer">
    <button
        class="btn btn-secondary"
        type="button"
        translate="TIME_INPUT_CANCEL"
        (click)="modalInstance.hide()"
    ></button>
    <button
        class="btn btn-primary"
        type="button"
        translate="TIME_INPUT_DONE"
        [disabled]="(is12HoursFormat && !meridiem) || timeInputForm.invalid"
        (click)="onSave()"
    ></button>
</div>
